import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "modal-footer text-right" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]

import { computed, toRef } from 'vue'
    import type { PortfolioProjectBuilderViewModel } from '@Projects/Components/PortfolioProjectBuilder'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioProjectBuilder',
  props: {
    viewModel: {}
  },
  emits: ["create-portfolio"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const creating = computed(() => vm.value.creating)

    const name = computed<string | null>({
        get: () => vm.value.name,
        set: val => { vm.value.name = val }
    })

    const description = computed<string | null>({
        get: () => vm.value.description,
        set: val => { vm.value.description = val }
    })

    const nameError = computed(() => vm.value.nameError)
    const descriptionError = computed(() => vm.value.descriptionError)

    // ---------------- methods ----------------

    function handleFormSubmit()
    {
        vm.value.creating = true
        emit('create-portfolio', name.value, description.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Create portfolio", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  id: "portfolio-project-builder-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", null, "Portfolio name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      type: "text",
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (nameError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(nameError.value), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description (optional):", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        description.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(descriptionError.value), 1 /* TEXT */)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  disabled: creating.value,
                  class: "btn btn-outline-secondary"
                }, "Cancel", 8 /* PROPS */, _hoisted_11),
                _createElementVNode("button", {
                  type: "submit",
                  form: "portfolio-project-builder-form",
                  disabled: creating.value,
                  class: "btn btn-primary"
                }, _toDisplayString(creating.value ? 'Creating...' : 'Create'), 9 /* TEXT, PROPS */, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})